module.exports = __webpack_public_path__ + "static/img/fwzc_02.ba67a8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/electronicDocuments/fwzc_02.png
// module id = 3Zho
// module chunks = 2